import { findIndex, clone, isString } from 'lodash'
import { cleanQuery } from '../utils'
import ErrorMixin from './ErrorMixin'
import DefaultValues from './DefaultValues'
import { mapState } from 'vuex'

/*
This mixin is simple generic getter of documents. It can work only if:
  service is defined in data (ex: service: this.$api.promoteurService)
You can define itemName to have error/success message more accurate (ex: itemName: 'promoteur')
You can define methods named beforeGet, afterSuccessGet, afterErrorGet, successGet, errorGet, beforeDelete, afterSuccessDelete, afterErrorDelete, errorDelete, successDelete
  to have a specific behavior at these cases
You can define perPage data to set number items to display
 */

export default {
  mixins: [ErrorMixin, DefaultValues],
  data () {
    return {
      multipleBuyer: false,
      fromClick: false,
      enableSaveQuery: true,
      items: [],
      loading: true,
      total: null,
      bigTotal: null,
      currentPage: 1,
      totalPage: 0,
      query: {},
      filters: {},
      initFilters: {},
      page: 1,
      sortBy: {},
      perPage: 100,
      deleteText: 'Êtes vous sûr de vouloir supprimer cet élément ?',
      opened: true,
      countLoading: false,
      infiniteLoaderEnabled: false,
      infiniteLoading: false
    }
  },
  computed: {
    ...mapState(['scrollToEl', 'scrollToPage']),
    nextPage () {
      if (!this.currentPage || !this.totalPage) {
        return null
      } else {
        if (this.currentPage && this.totalPage > this.currentPage) {
          return this.currentPage + 1
        } else {
          return null
        }
      }
    }
  },
  watch: {
    currentPage (to, from) {
      if (this.infiniteLoaderEnabled) return
      this.loadItems(to)
    }
  },
  methods: {
    beforeGet () {
      return undefined
    },
    afterSuccessGet (r) {
      return undefined
    },
    afterErrorGet (r) {
      this.handleError(r)
    },
    successGet (r) {
      this.loading = false
      this.infiniteLoading = false
      if (this.infiniteLoaderEnabled) {
        this.items = this.items.concat(r.data.items)
      } else {
        this.items = r.data.items
      }
      this.totalPage = r.data.pages
      this.currentPage = r.data.page
      this.total = r.data.total
      this.bigTotal = r.data.big_total
      if (!this.fromClick) {
        this.successScroll()
      }
      this.afterSuccessGet(r)
    },
    successScroll () {
      if (this.scrollToEl) {
        setTimeout(() => {
          let container = '#app'
          if (document.querySelector('#list')) container = '#list'
          if (this.$route.name === 'StockPrograms') {
            if (this.$route.query.tab === 'TABLE') {
              container = '#list'
            } else {
              container = '#app'
            }
          }
          this.$scrollTo(`#e${this.scrollToEl}`, 400, {container})
          // if (container === '#list') {
          //   var app = document.getElementById('app')
          //   app.scrollTop = app.scrollHeight
          // }
        }, 200)
      }
    },
    errorGet (r) {
      this.loading = false
      this.infiniteLoading = false
      this.afterErrorGet(r)
    },
    beforeDelete () {
      return undefined
    },
    afterSuccessDelete (r) {
      return undefined
    },
    afterErrorDelete (r) {
      return undefined
    },
    confirmDelete () {
      return this.$swal({
        title: 'Suppression',
        text: this.deleteText,
        confirmButtonText: 'Supprimer'
      })
    },
    errorDelete (r) {
      this.handleError(r)
      this.afterErrorDelete(r)
    },
    successDelete (id, r) {
      if (this.$route.name !== 'StockPrograms') {
        this.loading = false
        const i = findIndex(this.items, item => {
          return item.pk === id
        })
        if (i >= 0) {
          this.items.splice(i, 1)
          this.$notify({
            type: 'is-success',
            text: 'Élément supprimé.'
          })
        }
      } else {
        this.loading = false
        this.$notify({
          type: 'is-success',
          text: 'Élément supprimé.'
        })
      }
      this.afterSuccessDelete(id, r)
    },
    saveHistory (query) {
      delete query.page
      delete query.per_page
      let queryString = cleanQuery(query)
      history.pushState(null, null, `#${this.$route.path}?${queryString}`)
    },
    loadMore (val) {
      this.fromClick = val
      this.loadItems(this.nextPage, this.perPage, true)
    },
    async loadItems (page, perPage, fromInfiniteScroll = false) {
      console.log('loadItems')
      if (!fromInfiniteScroll) {
        this.loading = true
        this.items = []
      } else {
        this.infiniteLoading = true
      }
      if (!perPage) perPage = this.perPage || 100
      if (!page) page = this.page || 1
      if (this.beforeGet) this.beforeGet()
      try {
        let r = await this.service.get({page, per_page: perPage, ...this.query})
        if (this.enableSaveQuery) {
          this.saveHistory(this.query)
        }
        this.successGet(r)
        if (this.scrollToPage > r.data.page) {
          this.loadMore()
        }
      } catch (r) {
        this.errorGet(r)
      }
      // if (infiniteLoaderState) infiniteLoaderState.loaded()
    },
    deleteItem (id) {
      this.beforeDelete()
      this.confirmDelete().then(r => {
        if (r.value) {
          this.loading = true
          this.service.delete(id).then(r => {
            this.changeStore(this.service.url)
            this.successDelete(id, r.data)
          }).catch(err => {
            this.loading = false
            console.log(err)
            this.errorDelete(err)
          })
        }
      })
    },
    async changeStore (url) {
      if (url === 'promoteurs') {
        await this.getPromoteursStore()
      } else if (url === 'poles') {
        await this.getPolesStore()
      } else if (url === 'origins') {
        await this.getOriginsStore()
      } else if (url === 'companies') {
        await this.getCompaniesStore()
      }
    },
    getOriginsStore () {
      this.$api.originService.get().then(r => {
        this.$store.commit('setOrigins', {origins: r.data})
      })
    },
    getCompaniesStore (page = 1) {
      this.$api.companyService.get().then(r => {
        this.$store.commit('setCompanies', {companies: r.data})
        if (r.data.page < r.data.pages) {
          page++
          this.getCompanies(page)
        }
      })
    },
    getPromoteursStore (page = 1) {
      this.$api.promoteurService.get().then(res => {
        this.$store.commit('setPromoteurs', { promoteurs: res.data.items })
        if (res.data.page < res.data.pages) {
          page++
          this.getPromoteurs(page)
        }
      })
    },
    getPolesStore (page = 1) {
      this.$api.poleService.get().then(res => {
        this.$store.commit('setPoles', { poles: res.data.items })
        if (res.data.page < res.data.pages) {
          page++
          this.getPoles(page)
        }
      })
    },
    returnList (list, defaultList) {
      let returnItems = []
      if (Array.isArray(list)) {
        for (let item of list) {
          returnItems.push(defaultList.find(x => x.value === item))
        }
      } else {
        returnItems = [defaultList.find(x => x.value === list)]
      }
      return returnItems
    },
    async initQueryParams () {
      let queryFromRoute = Object.assign({}, this.$route.query)
      let outputQuery = {}
      if (queryFromRoute.program) {
        const { data } = await this.$api.programService.getOne(queryFromRoute.program)
        outputQuery.program = data
      }
      if (queryFromRoute.lot) {
        const { data } = await this.$api.lotService.getOne(queryFromRoute.lot)
        outputQuery.lot = data
      }
      if (queryFromRoute.promoteur) {
        const { data } = await this.$api.promoteurService.getOne(queryFromRoute.promoteur)
        outputQuery.promoteur = data
      }

      if (queryFromRoute.seller && this.multipleBuyer) {
        let sellers = []
        if (Array.isArray(queryFromRoute.seller) && queryFromRoute.seller) {
          const {data} = await this.$api.userService.get({pk: queryFromRoute.seller})
          sellers = data.items
        } else if (isString(queryFromRoute.seller)) {
          const {data} = await this.$api.userService.getOne(queryFromRoute.seller)
          sellers = [data]
        }
        outputQuery.seller = sellers
      } else if (queryFromRoute.seller) {
        const {data} = await this.$api.userService.getOne(queryFromRoute.seller)
        outputQuery.seller = data
      }

      if (queryFromRoute.origin) {
        let origins = []
        if (Array.isArray(queryFromRoute.origin) && queryFromRoute.origin) {
          const {data} = await this.$api.originService.get({pk: queryFromRoute.origin})
          origins = data
        } else if (isString(queryFromRoute.origin)) {
          const {data} = await this.$api.originService.getOne(queryFromRoute.origin)
          origins = [data]
        }
        outputQuery.origin = origins
      }
      if (queryFromRoute.csp) {
        outputQuery.csp = await this.returnList(queryFromRoute.csp, this.contactCspList)
      }
      if (queryFromRoute.family_situation) {
        outputQuery.family_situation = await this.returnList(queryFromRoute.family_situation, this.familySituationList)
      }
      if (queryFromRoute.matrimonial_status) {
        outputQuery.matrimonial_status = await this.returnList(queryFromRoute.matrimonial_status, this.matrimonalStatusList)
      }
      if (queryFromRoute.author) {
        const { data } = await this.$api.userService.getOne(queryFromRoute.author)
        outputQuery.author = data
      }
      // COMPANIES TOUJOURS EN SELECTION UNIQUE NE PAS TOUCHER
      if (queryFromRoute.company) {
        const { data } = await this.$api.companyService.getOne(queryFromRoute.company)
        outputQuery.company = data
      }
      if (queryFromRoute.contact) {
        const { data } = await this.$api.contactService.getOne(queryFromRoute.contact)
        outputQuery.contact = data
      }
      if (queryFromRoute.buyer) {
        const { data } = await this.$api.contactService.getOne(queryFromRoute.buyer)
        outputQuery.buyer = data
      }
      if (queryFromRoute.pole) {
        if (Array.isArray(queryFromRoute.pole)) {
          const { data } = await this.$api.poleService.get({pk: queryFromRoute.pole})
          outputQuery.pole = data.items
        } else {
          const { data } = await this.$api.poleService.getOne(queryFromRoute.pole)
          outputQuery.pole = [data]
        }
      }
      if (queryFromRoute.origin_type) {
        for (let type of this.originTypeList) {
          if (type.value === queryFromRoute.origin_type) {
            outputQuery.origin_type = await Object.assign({}, type)
          }
        }
      }
      Object.assign(this.filters, outputQuery)
    }
  },
  async created () {
    if (this.$route.query && this.enableSaveQuery) {
      this.query = clone(this.$route.query)
      this.page = clone(this.$route.query.page)
    }
    this.loading = true
    await this.initQueryParams()
    this.loading = false
    if (!this.service) {
      console.warn('service class must be defined in data ()')
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/GenericListMixin.js